import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";

const GroupBy = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.numberOfActiveMembersBy.filters.group_by);
  const selectedOption = useSelector(
    (state) => state.numberOfActiveMembersBy.selectedFilters.group_by
  );

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOption}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updateFilters({ group_by: data }))}
    />
  );
};
export default GroupBy;
